import { render, staticRenderFns } from "./consignmentAudit.vue?vue&type=template&id=fb63f44a&scoped=true"
import script from "./consignmentAudit.vue?vue&type=script&lang=js"
export * from "./consignmentAudit.vue?vue&type=script&lang=js"
import style0 from "./consignmentAudit.vue?vue&type=style&index=0&id=fb63f44a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb63f44a",
  null
  
)

export default component.exports